import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface AboutUs {
  id: number;
  title: string;
  titleMs: string;
  titleZh: string;
  airportName: string;
  videoUrl: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  createdAt: string;
  updatedAt: string;
  pagePublished: boolean;

  coreValuesTitle: string;
  coreValuesIcon: string;
  coreValuesDesc: string;
  coreValuesTitleZh: string;
  coreValuesDescZh: string;
  coreValuesTitleMs: string;
  coreValuesDescMs: string;

  missionTitle: string;
  missionIcon: string;
  missionDesc: string;
  missionTitleZh: string;
  missionDescZh: string;
  missionTitleMs: string;
  missionDescMs: string;

  visionTitle: string;
  visionIcon: string;
  visionDesc: string;
  visionTitleZh: string;
  visionDescZh: string;
  visionTitleMs: string;
  visionDescMs: string;
}

export interface ContactCentre {
  pageTitle: string;
  titleEnglish: string;
  titleMalay: string;
  titleMandarin: string;
  addressEnglish: string;
  addressMalay: string;
  addressMandarin: string;
}
export interface ContactUs {
  id: number;
  title: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  body: string;
  field_common_malay_description: string;
  field_common_mandarin_descriptio: string;
  field_email_address_en: string;
  field_email_address_ms: string;
  field_email_address_zh: string;
  field_mobile_number_en: string;
  field_mobile_number_ms: string;
  field_mobile_number_zh: string;
  field_message_ms: string;
  field_message_en: string;
  field_message_zh: string;
  created: string;
  changed: string;
}

export interface FormContact {
  id: number;
  title: string;
  field_name_en: string;
  field_name_ms: string;
  field_name_zh: string;
  field_category_en: string;
  field_category_ms: string;
  field_category_zh: string;
  field_message_en: string;
  field_message_ms: string;
  field_message_zh: string;
  field_note_text_en: string;
  field_note_text_ms: string;
  field_note_text_zh: string;
  field_submit_en: string;
  field_submit_ms: string;
  field_submit_zh: string;
  field_email_address_en: string;
  field_email_address_ms: string;
  field_email_address_zh: string;
  field_mobile_number_en: string;
  field_mobile_number_ms: string;
  field_mobile_number_zh: string;
}

export interface AwardsList {
  // Removed duplicate identifier
  id: number;
  title: string;
  field_page_title_en: number;
  field_page_title_ms: string;
  field_page_title_zh: string;
  bannerImage: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  awardsYear: string;
  createdAt: string;
  updatedAt: string;
  published: string;
  field_sub_published: boolean;
}
export interface BaggageGuide {
  id: number;
  title: string;
  image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  description: string;
  pageName: string;
  displayPath: string;
  createdAt: string;
  updatedAt: string;
  published: boolean;
}

interface DutyFreeBuyingGuide {
  // field_message_en: any;
  id: number;
  sNo: number;
  country_en: string;
  country_ms: string;
  country_zh: string;
  spirits_en: string;
  spirits_ms: string;
  spirits_zh: string;
  cigarettes_en: number | string;
  cigarettes_ms: string;
  cigarettes_zh: string;
  cigarettes: number;
  cigar_tobacco_en: string;
  cigar_tobacco_ms: string;
  cigar_tobacco_zh: string;
  cigarTobacco: string;
  field_airport: string;
  title: string;
  field_common_malay_title: string;
  field_common_mandarin_title: string;
  field_category_en: string;
  field_category_ms: string;
  field_category_zh: string;
  field_name_en: string;
  field_name_ms: string;
  field_name_zh: string;
  field_message_en: string;
  field_message_ms: string;
  field_message_zh: string;
  published: string;
}

export interface WelcomeNote {
  id: number;
  title: string;
  image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  description: string;
  pageName: string;
  displayPath: string;
  createdAt: string;
  updatedAt: string;
  published: boolean;
}

export interface TermsAndConditions {
  id: number;
  title: string;
  image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  pageName: string;
  displayPath: string;
  createdAt: string;
  updatedAt: string;
  published: boolean;
}

export interface News {
  id: number;
  newsImage: string;
  title: string;
  field_common_malay_title: string;
  field_common_mandarin_title: string;
  contentImage: string;
  date: string;
  body: string;
  field_common_malay_description: string;
  field_common_mandarin_descriptio: string;
  published: boolean;
  update: string;
}

interface Careers {
  id: number;
  title: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  bannerImage: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  noVancancyImage: string;
  vacancy: any[];
  createdAt: string;
  updatedAt: string;
  published: boolean;
}

export interface Faqs {
  id: number;
  title: string;
  field_common_malay_title: string;
  field_common_mandarin_title: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  published: string;
  field_sequence: string;
  field_created_date: string;
  field_updated_date: string;
}

export interface JobOpportunities {
  id: number;
  title_en: string;
  title_ms: string;
  title_zh: string;
  image: string;
  field_content_description_en: string;
  field_content_description_ms: string;
  field_content_description_zh: string;
  field_start_date: string;
  field_end_date: string;
  field_created_date: string;
  field_updated_date: string;
  published?: boolean | string;
}
export interface SingleCabinLuggagePolicySection1 {
  nid: string;
  english_title: string;
  malay_title: string;
  mandarin_title: string;
  description_english_1: string;
  description_malay_1: string;
  description_mandarin_1: string;
  description_english_2: string;
  description_malay_2: string;
  description_mandarin_2: string;
  image: string;
  description_english_3: string;
  description_malay_3: string;
  description_mandarin_3: string;
}
export interface SingleCabinLuggagePolicySection2 {
  description: string;
  image: string;
  nid: string;
  malay_title: string;
  mandarin_title: string;
  updatedAt: string;
  createdAt: string;
  published: string;
}
export interface GuidelinesForCheckedinLuggageSection1 {
  nid: string;
  english_title: string;
  malay_title: string;
  mandarin_title: string;
  tab_title_english: string;
  tab_title_malay: string;
  tab_title_mandarin: string;
}

export interface GuidelinesForCheckedinLuggageSection2 {
  english_title: string;
  image: string;
  nid: string;
  malay_title: string;
  mandarin_title: string;
  updatedAt: string;
  createdAt: string;
  published: string;
}

export interface RestrictedItemsSections {
  nid: string;
  english_title: string;
  malay_title: string;
  mandarin_title: string;
  english_title_2: string;
  malay_title_2: string;
  mandarin_title_2: string;
  english_title_3: string;
  malay_title_3: string;
  mandarin_title_3: string;
  tab_title_english: string;
  tab_title_malay: string;
  tab_title_mandarin: string;
}
export interface LagsSection3 {
  english_title: string;
  description_english_1: string;
  description_malay_1: string;
  description_mandarin_1: string;
  download_button_text_english: string;
  download_button_text_mandarin: string;
  download_button_text_malay: string;
  malay_title: string;
  mandarin_title: string;
  nid: string;
  pdf_url: string;
}
export interface LagsSection1 {
  nid: string;
  english_title: string;
  malay_title: string;
  mandarin_title: string;
  description_english_1: string;
  description_malay_1: string;
  description_mandarin_1: string;
  description_english_2: string;
  description_malay_2: string;
  description_mandarin_2: string;
  image: string;
  description_english_3: string;
  description_malay_3: string;
  description_mandarin_3: string;
  description_english_4: string;
  description_malay_4: string;
  description_mandarin_4: string;
  description_english_5: string;
  description_malay_5: string;
  description_mandarin_5: string;
}
export interface LagsSection4 {
  nid: string;
  description_english: string;
  description_malay: string;
  description_mandarin: string;
  description_english_2: string;
  description_malay_2: string;
  description_mandarin_2: string;
  description_english_3: string;
  description_malay_3: string;
  description_mandarin_3: string;
}

const fetchData = async <T>(url: string): Promise<T> => {
  const response = await eramanCMSApi.get<T>(url);
  console.log("fetchData", response, url);
  return response.data;
};

export const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

export const createDataHooksForPages =
  <T>(key: string, getUrl: (listId: string) => string) =>
  (
    listId: string,
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key, listId],
        enabled: false,
        queryFn: () => fetchData<T>(getUrl(listId)),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

const useAboutUs = createDataHook<AboutUs[]>("aboutUs", `/api/pages-about-us/all-fields`);

const useContactUs = createDataHook<ContactUs[]>("contactUs", `/api/contact-info/get-all-fields`);
const useContactForm = createDataHook<FormContact[]>("contactForm", `/api/pages-contactus/all-fields`);

const useDutyFreeBuyingGuide = createDataHooksForPages<DutyFreeBuyingGuide[]>(
  "dutyFreeBuyingGuide",
  (listId) => `/api/dutyfree-guide/all-fields/${listId}`
);

const useAwards = createDataHooksForPages<AwardsList[]>("awards", (listId) => `/api/pages-awards/${listId}`);

const useNews = createDataHooksForPages<News[]>("news", (listId) => `/api/news/all-fields/${listId}`);

const useCareersContent = createDataHook<Careers[]>("careersContent", `/api/pages-careers/284`);

const useFaqs = createDataHooksForPages<Faqs[]>("Faqs", (listId) => `/api/faqs/all-fields/${listId}`);

const useJobOpportunities = createDataHooksForPages<JobOpportunities[]>(
  "jobOpportunities",
  (listId) => `/api/job-opportunities-get-data-list/${listId}`
);

const useBaggageGuide = createDataHook<BaggageGuide[]>("baggageGuide", `/api/page-headers/244`);
const useSingleCabinLuggagePolicy = createDataHook<BaggageGuide[]>("singleCabinLuggagePolicy", `/api/page-headers/303`);
const useGuidelinesForCheckedinLuggage = createDataHook<BaggageGuide[]>(
  "guidelinesForCheckedinLuggage",
  `/api/page-headers/304`
);

const useLagsAndRestrictedItems = createDataHook<BaggageGuide[]>("lagsAndRestrictedItems", `/api/page-headers/243`);

const useLags = createDataHook<BaggageGuide[]>("lags", `/api/page-headers/305`);

const useRestrictedItems = createDataHook<BaggageGuide[]>("restrictedItems", `/api/page-headers/306`);

const useFooterContactInfo = createDataHook<ContactCentre[]>("footerContactInfo", `/api/contact-center/all-fields`);

const useWelcomeNote = createDataHook<WelcomeNote[]>("welcomeNote", `/api/page-headers/238`);

const useTermsAndConditions = createDataHook<TermsAndConditions[]>("TermsAndConditions", `/api/page-headers/241`);
const useSingleCabinLuggagePolicySection1 = createDataHook<SingleCabinLuggagePolicySection1[]>(
  "singleCabinLuggagePolicySection1",
  `/api/baggage/single-cabin/section-one`
);
const useSingleCabinLuggagePolicySection2 = createDataHooksForPages<SingleCabinLuggagePolicySection2[]>(
  "singleCabinLuggagePolicySection2",
  (listId) => `/api/baggage/single-cabin/section-two/${listId}`
);
const useGuidelinesForCheckedinLuggageSection1 = createDataHook<GuidelinesForCheckedinLuggageSection1[]>(
  "guidelinesForCheckedinLuggageSection1",
  `/api/baggage/checked-in/section-one`
);
const useGuidelinesForCheckedinLuggageSection2 = createDataHooksForPages<GuidelinesForCheckedinLuggageSection2[]>(
  "guidelinesForCheckedinLuggageSection2",
  (listId) => `/api/baggage/checked-in/section-two/${listId}`
);
const useLagsSection1 = createDataHook<LagsSection1[]>("lagsSection1", `/api/lags/section-one`);
const useLagsSection2 = createDataHooksForPages<SingleCabinLuggagePolicySection2[]>(
  "lagsSection2",
  (listId) => `/api/lags/section-two/${listId}`
);
const useRestrictedItemsSections = createDataHook<RestrictedItemsSections[]>(
  "restrictedItemsSections",
  `/api/restricted/item/section-one`
);
const useRestrictedItemsSectionsList = createDataHooksForPages<GuidelinesForCheckedinLuggageSection2[]>(
  "restrictedItemsSectionsList",
  (listId) => `/api/restricted/item/section-two/${listId}`
);
const useLagsSection3 = createDataHook<LagsSection3[]>("lagsSection3", `/api/lags/section-three`);
const useLagsSection4 = createDataHook<LagsSection4[]>("lagsSection3", `/api/lags/section-four`);
export {
  useAboutUs,
  useAwards,
  useBaggageGuide,
  useCareersContent,
  useContactForm,
  useContactUs,
  useDutyFreeBuyingGuide,
  useFaqs,
  useFooterContactInfo,
  useGuidelinesForCheckedinLuggage,
  useGuidelinesForCheckedinLuggageSection1,
  useGuidelinesForCheckedinLuggageSection2,
  useJobOpportunities,
  useLags,
  useLagsAndRestrictedItems,
  useLagsSection1,
  useLagsSection2,
  useLagsSection3,
  useLagsSection4,
  useNews,
  useRestrictedItems,
  useRestrictedItemsSections,
  useRestrictedItemsSectionsList,
  useSingleCabinLuggagePolicy,
  useSingleCabinLuggagePolicySection1,
  useSingleCabinLuggagePolicySection2,
  useTermsAndConditions,
  useWelcomeNote,
};
